// extracted by mini-css-extract-plugin
module.exports = {"browser-button":"styles-module__browser-button___3f7aI","placeholder":"styles-module__placeholder___3uM4S","placeholder-input":"styles-module__placeholder-input___2u7i9"};